"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterSizeOptions = void 0;
exports.defaultSfilterSizeOptions = [
    { name: '< 400', from: 0, to: 400 },
    { name: '400 - 600', from: 400, to: 600 },
    { name: '600 - 800', from: 600, to: 800 },
    { name: '800 - 1000', from: 800, to: 1000 },
    { name: '1000 - 1500', from: 1000, to: 1500 },
    { name: '1500+', from: 1500, to: -1 },
];
